<template>
  <div>
    <a-card class="customer-filter">
      <a-form-model :form="filterForm" :label-col="{ style: { width: '90px' } }" :model="filterForm" class="search-form">
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-model-item label="标题">
              <a-input v-model="filterForm.title" allow-clear placeholder="标题" class="form-model-item" @change="handleChange('title')" />
            </a-form-model-item>
          </a-col>
          <a-col :span="5">
            <a-form-model-item label="状态">
              <a-select v-model="filterForm.status" mode="multiple" allow-clear @change="handleChange('status')">
                <a-select-option v-for="(item, key) in workflowStatus" :key="key" :value="item.value">
                  <a-badge :status="item.status" :text="item.label" />
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="与我相关">
              <a-radio-group v-model="filterForm.about" button-style="solid" @change="handleChange('about')">
                <a-radio-button value="all"> 全部 </a-radio-button>
                <a-radio-button value="about"> 与我相关 </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item v-show="expand" label="创建时间">
              <a-input-group compact>
                <a-date-picker v-model="filterForm.start_date" style="width: 50%" placeholder="开始日期" value-format="YYYY-MM-DD" @change="handleChange('startDate')" />
                <a-date-picker v-model="filterForm.end_date" style="width: 50%" placeholder="结束日期" value-format="YYYY-MM-DD" @change="handleChange('endDate')" />
              </a-input-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="流程模板">
              <a-select v-model="filterForm.template_id" mode="multiple" allow-clear @change="handleChange('template_id')" @focus="getWorkflowTemplateList">
                <a-select-option v-for="(template, index) in workflowTemplates" :key="index" :value="template.id"> {{ template.name }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="5">
            <a-form-model-item v-show="expand" label="创建人">
              <user-select v-model="filterForm.creator" mode="multiple" allow-clear show-search show-all placeholder="创建人" :project-id="projectId" @change="handleChange('creator')" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="参与团队">
              <a-select v-model="filterForm.team" allow-clear @change="handleChange('team')" @focus="getTeamList">
                <a-select-option v-for="(team, index) in teamData" :key="index" :value="team.id"> {{ team.name }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item v-show="expand" label="参与人员">
              <a-input-group compact>
                <a-select v-model="filterForm.role" style="width: 30%" @change="handleChange('role')">
                  <a-select-option v-for="(role, key) in workflowRoles" :key="key" :value="role.value"> {{ role.label }} </a-select-option>
                </a-select>
                <user-select v-model="filterForm.users" style="width: 70%" mode="multiple" allow-clear show-search show-all :project-id="projectId" @change="handleChange('users')" />
              </a-input-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="关联需求">
              <a-select v-model="requirementValue" show-search allow-clear label-in-value :filter-option="false" :not-found-content="storySearching ? undefined : null" @search="searchStory" @change="handleStoryChange">
                <a-spin v-if="storySearching" slot="notFoundContent" size="small" />
                <a-select-option v-for="item in searchStoryData" :key="item.value" :value="item.value" :version="item.version">
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="5">
            <a-form-model-item v-show="expand" label="关联任务">
              <a-select v-model="taskValue" show-search allow-clear label-in-value :filter-option="false" :not-found-content="taskSearching ? undefined : null" @search="searchTask" @change="handleTaskChange">
                <a-spin v-if="taskSearching" slot="notFoundContent" size="small" />
                <a-select-option v-for="item in searchTaskData" :key="item.value" :value="item.value" :version="item.version">
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="当前步骤">
              <a-tree-select v-model="filterForm.steps" show-search :filter-tree-node="filterModule" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" style="width: 100%" placeholder="请选择当前步骤" :tree-data="stepTree" tree-node-label-prop="label" multiple @change="handleChange('steps')" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6" style="float: right; text-align: right">
            <a-form-model-item>
              <a-button v-tc="{ name: '查询' }" type="primary" @click="getWorkFlowList">查询</a-button>
              <a-button v-tc="{ name: '重置' }" :style="{ margin: '0 12px' }" @click="onReset">重置</a-button>
              <a v-tc="{ name: '收起/展开' }" class="ant-dropdown-link" @click="expand = !expand">{{ expand ? '收起' : '展开' }} <a-icon :type="expand ? 'up' : 'down'" /> </a>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <a-card title="流程列表" class="filter-data">
      <a-space slot="extra">
        <workflow-view ref="view" @setFilter="setFilter" />
        <a-button v-tc="{ name: '添加流程' }" class="handle-menu" type="primary" icon="plus" @click="onAdd">添加流程</a-button>
      </a-space>
      <a-table table-layout="fixed" :show-header="false" :pagination="pagination" :columns="columns" size="middle" :data-source="tableData" row-key="id" :loading="loading" @change="handlePageChange">
        <span slot="action" slot-scope="text, record">
          <a v-tc="{ name: '查看流程详情' }" class="ant-dropdown-link" @click="onDetail(record)">查看</a>
          <a-divider type="vertical" />
          <a-dropdown placement="bottomCenter">
            <a class="ant-dropdown-link" :disabled="!record.modify_permission || ![0, 1].includes(record.status.value)">更多<a-icon type="down" /> </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a v-tc="{ name: '编辑流程' }" class="ant-dropdown-link" @click="onEdit(record)">编辑流程</a>
              </a-menu-item>
              <a-menu-item>
                <a v-tc="{ name: '终止流程' }" class="ant-dropdown-link" @click="onStop(record)">终止流程</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
        <div slot="avatar" slot-scope="text, record" style="position: relative">
          <a-avatar shape="square" :size="48" icon="user" :src="record.creator.avatar_url" class="table-image" />
          <div v-if="record.template_level === 2" class="ribbon-wrapper">
            <div class="ribbon ribbon-pre">DEMO</div>
          </div>
          <div v-if="record.template_level === 3" class="ribbon-wrapper">
            <div class="ribbon ribbon-prod">PROD</div>
          </div>
        </div>
        <span slot="titleCreator" slot-scope="text, record">
          <span class="workflow-value">
            标题:
            <a-tooltip v-if="![0, null].includes(record.parent_id)" placement="top" title="流程已被关联">
              <a-icon type="star" theme="filled" class="is_relation" />
            </a-tooltip>
            <a v-tc="{ name: '跳转流程详情' }" class="custom-link" :href="getDetailLink(record)" target="_blank">
              <span v-if="record.no_need_qa === 1" class="gold-span">免验</span>
              {{ record.title }}
            </a>
          </span>
          <span class="workflow-value">模板: {{ record.template_name }}</span>
        </span>
        <span slot="templateType" slot-scope="text, record">
          <span class="workflow-value">类型: {{ record.workflow_type.label }}</span>
          <span class="workflow-value">创建人: <user-profiles :value="[record.creator.id]" /></span>
        </span>

        <span slot="statusStep" slot-scope="text, record">
          <span class="workflow-value">当前状态: <a-badge :status="workflowStatus[record.status.value].status" :text="workflowStatus[record.status.value].label" /> </span>
          <span class="workflow-value">当前步骤: {{ record.step_name }}</span>
        </span>
        <span slot="time" slot-scope="text, record">
          <span class="workflow-value">创建时间: {{ record.created_time }}</span>
          <span class="workflow-value">更新时间: {{ record.updated_time }}</span>
        </span>
        <span slot="progress" slot-scope="text, record">
          <a-progress stroke-linecap="square" :percent="record.progress" type="circle" :status="record.status.value === 3 ? 'exception' : null" :width="50" :stroke-width="11" />
        </span>
      </a-table>
    </a-card>
    <workflow-stop-modal ref="workflowStopModalRef" @ok="getWorkFlowList" />
    <workflow-modify-modal ref="workflowModifyModalRef" @ok="getWorkFlowList" />
  </div>
</template>

<script>
import { teamList } from '@/api/system/team';
import { taskSearch } from '@/api/project/task';
import { storySearch } from '@/api/project/story';
import { workflowStatus, workflowRoles } from '@/utils/dictionary';
import { workflowList, workflowTemplateList, getTemplateStepTree } from '@/api/project/workflow';

import moment from 'moment';
import UserSelect from '@/components/User/UserSelect';
import WorkflowView from '@/pages/project/workflow/components/WorkflowView';
import WorkflowStopModal from '@/pages/project/workflow/components/WorkflowStopModal';
import WorkflowModifyModal from '@/pages/project/workflow/components/WorkflowModifyModal';

export default {
  components: { UserSelect, WorkflowStopModal, WorkflowModifyModal, WorkflowView },
  data() {
    return {
      loading: false,
      workflowRoles,
      workflowStatus,
      projectId: parseInt(this.$route.params.project_id) || null,
      filterForm: {
        project_id: parseInt(this.$route.params.project_id) || null,
        about: this.$route.query.about || 'all',
        title: this.$route.query.title || null,
        template_id: this.$route.query.template_id ? this.$route.query.template_id.split(',').map(item => parseInt(item)) : [],
        creator: this.$route.query.creator ? this.$route.query.creator.split(',').map(item => parseInt(item)) : [],
        status: this.$route.query.status ? this.$route.query.status.split(',').map(item => parseInt(item)) : [],
        team: parseInt(this.$route.query.team) || null,
        start_date: this.$route.query.start_date || null,
        end_date: this.$route.query.end_date || null,
        role: this.$route.query.role || 'DEV',
        users: this.$route.query.users ? this.$route.query.users.split(',').map(user => parseInt(user)) : [],
        page_size: parseInt(this.$route.query.page_size) || 20,
        page_number: parseInt(this.$route.query.page_number) || 1,
        steps: []
      },
      createdDate: [],
      pagination: {
        size: 'large',
        total: 0,
        current: parseInt(this.$route.query.page_number) || 1,
        pageSize: parseInt(this.$route.query.page_size) || 20, // 每页中显示20条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      expand: true,
      workflowId: null,
      columns: [
        {
          title: '头像',
          width: 60,
          align: 'center',
          scopedSlots: { customRender: 'avatar' }
        },
        {
          ellipsis: true,
          scopedSlots: { customRender: 'titleCreator' }
        },
        {
          width: '12%',
          scopedSlots: { customRender: 'templateType' }
        },
        {
          width: '14%',
          scopedSlots: { customRender: 'statusStep' }
        },
        {
          align: 'center',
          width: '20%',
          scopedSlots: { customRender: 'time' }
        },
        {
          align: 'center',
          width: '5%',
          scopedSlots: { customRender: 'progress' }
        },
        {
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      teamData: [],
      workflowTemplates: [],
      tableData: [],
      requirementValue: {},
      storySearching: false,
      searchStoryData: [],
      taskValue: {},
      taskSearching: false,
      searchTaskData: [],
      stepTree: []
    };
  },
  created() {
    this.getTempStepTreeData();
    if (this.filterForm.team !== null) {
      this.getTeamList();
    }
    if (this.filterForm.template_id !== null) {
      this.getWorkflowTemplateList();
    }
    if (this.$route.query.start_date !== null && this.$route.query.end_date !== null) {
      this.createdDate = [this.$route.query.start_date, this.$route.query.end_date];
    }
    this.pagination.current = this.filterForm.page_number;
  },
  methods: {
    getTempStepTreeData() {
      getTemplateStepTree({}).then(res => {
        this.stepTree = res.data.items;
      });
    },
    // 模块筛选
    filterModule(searchValue, treeNode) {
      return treeNode.data.props.title.includes(searchValue);
    },
    // 需求搜索
    searchStory(value) {
      storySearch({ project_id: this.projectId, value: value }).then(res => {
        this.searchStoryData = res.data.items;
      });
    },
    // 任务搜索
    searchTask(value) {
      taskSearch({ project_id: this.projectId, value: value }).then(res => {
        this.searchTaskData = res.data.items;
      });
    },

    handleStoryChange(value, option) {
      if (value) {
        this.filterForm.requirement_id = value.key;
      } else {
        this.filterForm.requirement_id = null;
      }

      this.handleChange('requirement_id');
    },
    handleTaskChange(value, option) {
      if (value) {
        this.filterForm.task_id = value.key;
      } else {
        this.filterForm.task_id = null;
      }

      this.handleChange('task_id');
    },

    getWorkflowTemplateList() {
      workflowTemplateList({ status: 0 }).then(res => {
        this.workflowTemplates = res.data.items;
      });
    },

    // 获取工作流列表
    getWorkFlowList() {
      this.loading = true;
      workflowList(this.filterForm)
        .then(res => {
          this.tableData = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    // 添加工作流
    onAdd() {
      this.$router.push({ name: 'page:project:workflow:create' });
    },

    /**
     * 终止工作流
     * @param {*} record
     */
    onEdit(record) {
      this.$nextTick(() => {
        this.$refs.workflowModifyModalRef.onOpen(record.id, record.project.id);
      });
    },
    /**
     * 编辑工作流
     * @param {*} record
     */
    onStop(record) {
      this.$nextTick(() => {
        this.$refs.workflowStopModalRef.onOpen(record.id, record.project.id);
      });
    },

    // 重置查询
    onReset() {
      this.createdDate = [];
      this.filterForm.about = 'all';
      this.filterForm.title = null;
      this.filterForm.start_date = null;
      this.filterForm.end_date = null;
      this.filterForm.creator = [];
      this.filterForm.status = [];
      this.filterForm.template_id = [];
      this.filterForm.team = null;
      this.filterForm.page_number = 1;
      this.filterForm.page_size = 20;
      this.filterForm.role = 'DEV';
      this.filterForm.users = [];
      this.requirementValue = {};
      this.filterForm.requirement_id = null;
      this.taskValue = {};
      this.filterForm.task_id = null;
      this.filterForm.steps = [];
      this.pagination.current = 1;
      this.pagination.pageSize = 20;
      this.$router.push({ name: 'page:project:workflow:list' });
      this.getWorkFlowList();
    },

    // 获取工作流详情链接
    getDetailLink(record) {
      const route = this.$router.resolve({
        name: 'page:project:workflow:detail',
        query: { workflowId: record.id }
      });
      return route.href;
    },

    onDetail(record) {
      this.$router.push({
        name: 'page:project:workflow:detail',
        query: { workflowId: record.id }
      });
    },

    // 筛选内容变更
    handleChange(item = null) {
      const customerQuery = { ...this.$route.query };
      if (item.includes(['title']) && this.filterForm[item] === '') {
        this.$set(this.filterForm, item, null);
        delete customerQuery.title;
      } else if (item === 'role' || item === 'users') {
        if (this.filterForm.users && this.filterForm.users.length > 0) {
          this.$set(customerQuery, 'role', this.filterForm.role);
          this.$set(customerQuery, 'users', this.filterForm.users.toString());
        } else {
          delete customerQuery['role'];
          delete customerQuery['users'];
        }
      } else if (item === 'createdDate') {
        if (this.createdDate.length > 0) {
          this.filterForm.start_date = moment(this.createdDate[0]).format('YYYY-MM-DD');
          this.filterForm.end_date = moment(this.createdDate[1]).format('YYYY-MM-DD');
          this.$set(customerQuery, 'start_date', this.filterForm.start_date);
          this.$set(customerQuery, 'end_date', this.filterForm.end_date);
        } else {
          this.filterForm.start_date = null;
          this.filterForm.end_date = null;
          delete customerQuery['start_date'];
          delete customerQuery['end_date'];
        }
      } else if (['template_id', 'creator', 'status'].includes(item)) {
        if (this.filterForm[item].length > 0) {
          this.$set(customerQuery, item, this.filterForm[item].join(','));
        } else {
          delete customerQuery[item];
        }
      } else {
        this.$set(customerQuery, item, this.filterForm[item]);
      }

      this.filterForm.page_number = 1;
      this.pagination.current = 1;
      if (customerQuery.page_number !== undefined) {
        this.$set(customerQuery, 'page_number', 1);
      }
      this.$router.push({ name: 'page:project:workflow:list', query: customerQuery });
      this.getWorkFlowList();
    },

    // 页面变更
    handlePageChange(pagination) {
      this.pagination = pagination;
      const customerQuery = { ...this.$route.query };
      this.filterForm.page_size = pagination.pageSize;
      this.filterForm.page_number = pagination.current;
      this.$set(customerQuery, 'page_size', pagination.pageSize);
      this.$set(customerQuery, 'page_number', pagination.current);
      this.$router.push({ name: 'page:project:workflow:list', query: customerQuery });
      this.getWorkFlowList();
    },

    // 获取团队列表
    getTeamList() {
      teamList({}).then(res => {
        this.teamData = res.data.items;
      });
    },

    setFilter(filter) {
      this.filterForm = {
        ...filter,
        role: filter.role ? filter.role : 'DEV',
        about: filter.about ? filter.about : 'all',
        project_id: this.projectId,
        page_size: 20,
        page_number: 1
      };
      this.pagination.pageSize = 10;
      this.pagination.current = 1;
      this.getWorkFlowList();
    },

    // 关闭弹框的回调
    close(type = 'close') {
      this.stopVisible = false;
      this.editVisible = false;
      if (type === 'close') {
        this.getWorkFlowList();
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: 8px;
  display: flex;

  .ant-form-item-control-wrapper {
    flex: 1;
  }
}

.filter-data {
  margin-top: 16px;
}

.workflow-lable {
  max-width: 68px;
  line-height: 24px;
  text-align: right;
  display: inline-block;
}

.workflow-value {
  line-height: 24px;
  width: 100%;
  display: block;
  word-break: keep-all;
  /* 不换行 */
  white-space: nowrap;
  /* 不换行 */
  overflow: hidden;
  /* 内容超出宽度时隐藏超出部分的内容 */
  text-overflow: ellipsis;
  /* 当对象内文本溢出时显示省略标记(...) ；
                                需与 overflow:hidden;一起使用。*/
}

.workflow-stop-button {
  color: #ff4d4f;
}

.custom-link {
  color: rgba(0, 0, 0, 0.65);
}

.custom-link:hover {
  color: #1890ff;
}

.ribbon-wrapper {
  width: 54px;
  height: 54px;
  overflow: hidden;
  position: absolute;
  top: -4px;
  left: -4px;

  .ribbon {
    font: bold 12px Sans-Serif;
    line-height: 12px;
    color: #333;
    text-align: center;
    text-transform: uppercase;
    transform: rotate(-45deg);
    position: relative;
    padding: 3px 8px;
    left: -17px;
    top: 9px;
    width: 70px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    letter-spacing: 0.5px;
    outline: 1px solid #fff;
    outline-offset: -2px;
  }

  .ribbon-prod {
    background-color: orange;
    color: #fff;
  }

  .ribbon-pre {
    background-color: #2db7f5;
    color: #fff;
  }
}

.is_relation {
  color: orange;
  margin-right: 2px;
}

.gold-span {
  border: 1px solid green;
  color: green;
  padding: 4px;
  border-radius: 8px;
  font-size: 11px;
}
</style>
